import { PaymentConfigurationError } from "../../errors/PaymentConfigurationError";

/**
 * Error thrown when an error related to Stripe wallets happens.
 *
 * Ties the UI-layer at StripeWalletElement and the payments logic at StripePaymentGateway together.
 */
export class StripeWalletPaymentError extends PaymentConfigurationError {
  constructor(
    technicalMessage: string,
    options?: {
      userMessage?: string;
      metadata?: Record<string, unknown>;
    }
  ) {
    super(technicalMessage, {
      userMessage: options?.userMessage,
      metadata: options?.metadata,
    });
  }
}
